var map = {
	"./ApplicationStatus.vue": [
		3476,
		416
	],
	"./Autosave.vue": [
		3477,
		479
	],
	"./ChangeAuthor.vue": [
		3478,
		480
	],
	"./ChangeType.vue": [
		3479,
		481
	],
	"./Cooldown.vue": [
		3480,
		417
	],
	"./CourseRelease.vue": [
		3481,
		418
	],
	"./Demo.vue": [
		3487,
		512
	],
	"./Demo2.vue": [
		3488,
		513
	],
	"./EditorSettings.vue": [
		3482,
		482
	],
	"./Hint.vue": [
		3475
	],
	"./ModuleRelease.vue": [
		3483,
		419
	],
	"./Practice.vue": [
		3484,
		420
	],
	"./Reorder.vue": [
		3485,
		483
	],
	"./Vacancies.vue": [
		3486,
		484
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 3332;
module.exports = webpackAsyncContext;